import { createGlobalStyle } from "styled-components";
import tokens from "../theme/tokens";

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400;1,9..40,500&family=Poppins:wght@500;600;700&display=swap');

  @import-normalize;

  * {
   box-sizing: border-box;
   text-decoration: none;
   font-family: 'DM Sans', sans-serif;
  }

  *:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${tokens.colors.focusRing};
  }

  html {
   --black: #000000;
   --black100: ${tokens.colors.ink};
   --black75PercentOff: rgba(0, 0, 0, 0.25);
   --white: #FFFFFF;
   --Gray100:#C9C9C9;
   --Gray600:${tokens.colors.inkSecondary};
   --darkGrey: #272727;
   --darkSlateGray: ${tokens.colors.inkSecondary};
   --cyanBlue: ${tokens.colors.primary};
   --darkSlateGray100: #323232;
   --lightGrey: ${tokens.colors.border};
   --lightGrey100: ${tokens.colors.border};
   --lightGrey200: ${tokens.colors.inkFaint};
   --lightGrey300: #4E4F5E;
   --lightGrey400: ${tokens.colors.inkFaint};
   --lightGrey500: ${tokens.colors.inkMuted};
   --lightGrey600: ${tokens.colors.inkMuted};
   --lightGrey700: #787579;
   --errorRed: ${tokens.colors.error.main};
   --correctGreen: ${tokens.colors.success.main};
   --grey400 : ${tokens.colors.inkMuted};
   --lightBlue : ${tokens.colors.primaryTint};
   --lightBlue100: ${tokens.colors.primary};
   --errorBg: ${tokens.colors.error.bg};
   --errorText: ${tokens.colors.inkSecondary};
   --warningBg: ${tokens.colors.warning.bg};
   --warningOrange: ${tokens.colors.warning.fg};
   --gray800:${tokens.colors.ink};
 }

  body {
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
    box-sizing: border-box;
    overflow: hidden;
    background: ${tokens.colors.pageBg};
  }

  .hidden-mobile {
    @media(max-width:600px){
      display: none !important;
    }
  }

  .hidden-desktop {
    @media(min-width:600px){
      display: none !important;
    }
  }

  .visible_hidden {
    visibility: hidden;
  }

  .hidden_all {
    display: none !important;
  }

  /* Override native input checkbox to use accent color */
  input[type="checkbox"] {
    cursor: pointer;
    accent-color: ${tokens.colors.primary};
  }
`;
